import { IScreen } from "../common/data/dtos/screen";
import { GET_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/Screen';

interface ScreenResponse {
    success: boolean;
    screen?: IScreen;
    screens?: IScreen[];
    error?: string;
}

type CreateScreenType = Omit<IScreen, 'id'> | Partial<IScreen>;

const getScreens = async (): Promise<ScreenResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IScreen>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, screens: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    getScreens
};